import * as React from 'react';
import { style } from 'typestyle';
import { horizontal, horizontallySpaced, vertical, verticallySpaced } from 'csstips';
import { colorWhite } from '../theme/color';
import { px } from 'csx';
import { resetAnchorStyles } from '../theme/reset';
import { mediaDesktop, mediaMobileOnly, mediaTablet, mediaUpToTablet } from '../theme/media';

export interface FooterSection {
  title: string;
  items: Array<{
    text: string;
    path: string;
    external?: boolean;
    Icon?: string;
  }>;
}

export interface AppFooterSectionProps extends FooterSection {
  onClickLink(event: React.MouseEvent<any>): void;
  horizontal?: boolean;
}

const styles = {
  container: style(
    {
      color: colorWhite.toString(),
      paddingBottom: px(30),
      $nest: {
        '&> ul': {
          listStyleType: 'none',
          padding: px(0),
        },
        '&> h4': {
          margin: px(0),
          fontSize: px(20),
        },
      },
    },
    mediaDesktop({
      width: `calc(25% - 40px)`,
    }),
    mediaUpToTablet({
      width: `calc(33% - 40px)`,
    }),
    mediaMobileOnly({
      flex: '1 1 50%',
      $nest: {
        '&> ul': {
          listStyleType: 'none',
          fontSize: px(14),
          padding: px(0),
        },
      },
    }),
  ),
  link: style({
    display: 'block',
    color: colorWhite.toString(),
    textDecoration: 'none',
    $nest: {
      ...resetAnchorStyles(),
    },
  }),
  horizontal: style({
    ...horizontal,
    ...horizontallySpaced(10),
    $nest: {
      '&> li': {
        display: 'block',
      },
    },
  }),
};

export const AppFooterSection: React.SFC<AppFooterSectionProps> = ({ horizontal, title, items, onClickLink }) => (
  <div className={styles.container}>
    <h4>{title}</h4>
    <ul className={horizontal ? styles.horizontal : void 0}>
      {items.map(({ text, path, Icon, external }, index) => (
        <li key={index.toString()}>
          <a
            className={styles.link}
            href={path}
            key={index}
            onClick={onClickLink}
            target={external ? '_blank' : void 0}
          >
            {Icon && <Icon />}
            {!Icon && text}
          </a>
        </li>
      ))}
    </ul>
  </div>
);
